"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloudIdentifiersClient = void 0;
const tslib_1 = require("tslib");
const authenticated_client_1 = require("./authenticated.client");
class CloudIdentifiersClient extends authenticated_client_1.AuthenticatedClient {
    constructor() {
        super(...arguments);
        this.baseRoute = '/v1/cloud-identifiers';
    }
    getAll() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { payload } = yield this.httpGet(this.baseRoute);
            return payload;
        });
    }
}
exports.CloudIdentifiersClient = CloudIdentifiersClient;
//# sourceMappingURL=cloud-identifiers.client.js.map